import React from 'react';
import './index.scss';
import { TrustPilotWidget } from './trustPilotWidget';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';

const TrustpilotMain = () => {
  const { t } = useTranslation();
  return (
    <section className="trustpilotMain">
      <div className="trustpilotWidget">
        <h2>{t('What people are saying')}</h2>
        <div className="trustpilotContainer">
          <TrustPilotWidget />
        </div>
      </div>
      <div className="logoLinks">
        <div className="innerContainer">
          <ul>
            <li>
              <a
                target="_blank"
                href="https://www.washingtonpost.com/lifestyle/home/prescription-discount-programs-save-money/2021/06/28/7d9a00c4-d2a4-11eb-a53a-3b5450fdca7a_story.html"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/logo-the-washington-post.svg"
                  height="44"
                  width="289"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.wsj.com/articles/some-companies-make-their-websites-more-elderly-friendly-11603569592"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/logo-wsj.svg"
                  height="30"
                  width="347"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.usatoday.com/story/news/health/2021/12/10/flu-rise-during-covid-experts-urge-americans-get-flu-shots/6445148001/"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/usa-today.svg"
                  height="31"
                  width="172"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.yahoo.com/video/finance/singlecare-ceo-rising-number-americans-221805128.html"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/yahoo.svg"
                  height="31"
                  width="114"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.fastcompany.com/90457848/health-most-innovative-companies-2020"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/logo-fast-company.svg"
                  height="30"
                  width="205"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.forbes.com/sites/danieldambrosio/2019/08/12/boston-startup-signs-up-millions-for-lower-prescription-drug-costs/?sh=78b97c61ea44"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/logo-forbes.svg"
                  height="30"
                  width="113"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.healthline.com/health/best-prescription-discounts "
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/healthline.svg"
                  height="24"
                  width="143"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.realsimple.com/work-life/money/saving/save-money-on-prescription-drugs"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src="/content/images/apps/real-simple.svg"
                  height="21"
                  width="178"
                  alt=""
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TrustpilotMain;
